import React, { useState, useEffect } from "react";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import Moment from "react-moment";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddWareHouseTransfer from "./AddWareHouseTransferForm";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "productName", label: "Product Name" },
  { id: "quantity", label: "Quantity Transfered" },
  { id: "locationName", label: "From Storage (Location Name)" },
  { id: "locationName", label: "To Storage (Location Name)" },
  { id: "locationName", label: "Date Transferred" },
];

export function InventoryReports({
  locations,
  LoadWareHouseTransfer,
  userId,
  wareHouseTransferList,
  products,
  locationsDropDown,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(wareHouseTransferList, headCells, filterFn);
  var i = 0;
  useEffect(() => {
    LoadWareHouseTransfer(userId);
    return () => {};
  }, []);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.productName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    //   DeleteLocation(id)
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <>
      <div className="container" style={{}}>
        <div className="mt-4" style={{}}>
          <Column>
            <ToastContainer />
            <Paper className={classes.pageContent}>
              <h4>
                <strong>Inventory Reports</strong>
              </h4>
            </Paper>
            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  console.log(state);
  return {
    locations: state.locationReducer.locationDrop,
    products: state.productReducer.productList,
    userId: state.persistReducer.userId,
    wareHouseTransferList: state.inventoryReducer.wareHouseTransferList,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadWareHouseTransfer(payload) {
    dispatch({ type: "LOAD_INVENTORY_TRANSFER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryReports);
